import api from 'api'
import axios from 'axios'

import { signOut } from 'actions/auth'
import { fetchCredits } from 'actions/creditBalance'

import { sendNativeMessage } from 'util/native'

export function getProfile() {
  return dispatch => {
    console.log('Loading profile', new Date())
    return api.get('my_profile').then(resp => {
      const { profile } = resp.data
      dispatch(fetchCredits())
      dispatch(getMessages())
      dispatch(getAuthenticityVerification())
      dispatch(getEarnings())
      console.log('Loading profile complete', new Date())
      return dispatch({ type: 'SET_PROFILE', profile })
    }).catch(err => {
      let message
      if (err.response && err.response.status === 401)  {
        message = `You signed out.`
      } 
      dispatch(signOut({ message }))
    })
  }
}

export function getMessages() {
  return dispatch => {
    return axios.get(process.env.REACT_APP_MESSAGES_URL).then(resp => {
      return dispatch({ type: 'SET_MESSAGES', messages: resp.data })
    })
  }
}

export function seenMessage(id) {
  return dispatch => {
    // TODO: Notify backend of seen
    return dispatch({ type: 'SEEN_MESSAGE', id })
  }
}

export function verifyPhone(code) {
  return dispatch => {
    return api.post('user/phone_number_confirmation', { phone_number_verification_code: code }).then(resp => {
      return dispatch(getProfile())
    })
  }
}

export function resendPhoneVerificationCode() {
  return dispatch => {
    return api.put('user/phone_number_confirmation')
  }
}

export function updatePhoneNumber(phone_number) {
  return dispatch => {
    return api.put('my_profile/phone_number', { phone_number }).then(resp => {
      return dispatch(getProfile())
    })
  }
}

export function updateProfile(data) {
  return dispatch => {
    return api.put('my_profile', data).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function addVehicle(data) {
  return dispatch => {
    return api.post('vehicles', { vehicle: { ...data }}).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function updateVehicle(id, { color, category }) {
  return dispatch => {
    return api.put(`vehicles/${id}`, { vehicle: { color, category }}).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function updateDriversLicense({ state, number, expiration_date }) {
  return dispatch => {
    return api.version(2).post('drivers_license', { state, number, expiration_date }).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function addDebitCard({ stripe_token, last4, expiration_month, expiration_year }) {
  return dispatch => {
    return api.version(3).post('profile/debit_accounts', { account_token: stripe_token, account_last_four: last4, expiration_month, expiration_year }).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function addBankAccount({ routing_number, account_number, account_type = 'checking', account_holder_type = 'personal' }) {
  return dispatch => {
    return api.post('profile/bank_accounts', { bank_account: {
      routing_number, account_number, account_type, account_holder_type,
    }}).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function updateBankAccount(id, { routing_number, account_number, account_type = 'checking', account_holder_type = 'personal' }) {
  return dispatch => {
    return api.patch(`profile/bank_accounts/${id}`, { bank_account: {
      routing_number, account_number, account_type, account_holder_type,
    }}).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function verifyBankAccount(id, deposits) {
  return dispatch => {
    return api.patch(`profile/bank_accounts/${id}/verify`, { deposits }).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function saveCreditCard(data, silenceDispatch=false) {
  return dispatch => {

    const { payment_provider, ...params } = data

    let payload

    if (payment_provider === 'stripe') {
      try {

        console.log(params.stripe_card)

        payload = {
          credit_card: {
            stripe_token: params.stripe_card.id,
            account_number: params.stripe_card.card.last4,
            expiration_month: String(params.stripe_card.card.exp_month),
            expiration_year: String(params.stripe_card.card.exp_year),
          }
        }
      } catch (er) {
        console.log('er', er)
        throw er;
      }
    } else {
      const [expiration_month, expiration_year] = params.credit_card.expiration_date.split('/').map(Number)
      const credit_card = Object.assign({}, params.credit_card, { expiration_month, expiration_year })
      delete credit_card.expiration_date
      credit_card.account_number = credit_card.account_number.replace(/\s/g, '')
      payload = { credit_card }
    }

    return api.post('profile/credit_cards', payload).then(resp => {
      if (!silenceDispatch) {
        return dispatch(getProfile())
      }
    })
  }
}

export function updatePhoto(file) {
  return dispatch => {
    const data = new FormData()
    data.append('file', file)
    return api.put('my_profile/avatar', data).then(() => {
      return dispatch(getProfile())
    })
  }
}

export function addCert(type, options = {}) {
  const { refetchProfile = true } = options
  return dispatch => {
    const promise = api.post('profile/certifications', { type })
    
    if (refetchProfile) {
      return promise.then(() => {
        return dispatch(getProfile())
      })
    }

    return promise
  }
}

export function agreeToTerms(payload) {
  return dispatch => {
    return api.version(3).post('profile/terms', payload).then(() => {
      sendNativeMessage({ type: 'TERMS_ACCEPTED' })
      return dispatch(getProfile())
    })
  }
}

export function addDriverCert(name) {
  return dispatch => {
    return api.version(3).post('my_profile/delivery_certifications_drivers', { name })
      .then(() => dispatch(fetchDriverCerts()))
  }
}

export function fetchDriverCerts() {
  return dispatch => {
    return api.version(3).get('my_profile/delivery_certifications_drivers')
      .then(res => {
        dispatch(saveTrainingCertificationsToStore(res.data))
        return res.data
      })
  }
}

export function saveTrainingCertificationsToStore(data) {
  return dispatch => {
    return dispatch({ type: 'SET_TRAINING_CERTS', data })
  }
}

export function getAuthenticityVerification() {
  return dispatch => {
    return api.get('my_profile/authenticity_verification')
      .then(res => {
        dispatch({ type: 'SET_AUTHENTICITY_VERIFICATION', state: res.data.state })
      })
  }
}

export function getEarnings() {
  return dispatch => {
    return api.version(3).get('/my_profile/earnings_statements')
      .then(res => {
        dispatch({ type: 'SET_EARNINGS_STATEMENT', earningsStatement: res.data.earnings_statements })
      })
  }
}
